// @constants
export const COLLAPSE_MAIN_MENU = 'COLLAPSE_MAIN_MENU';
export const EXPAND_MAIN_MENU = 'EXPAND_MAIN_MENU';

export const collapseMainMenu = () => ({
    type: COLLAPSE_MAIN_MENU
});

export const expandMainMenu = () => ({
    type: EXPAND_MAIN_MENU
});
